import { createTailwindcss, type TailwindConfig } from '@mhsdesign/jit-browser-tailwindcss';
import resolveConfig from 'tailwindcss/resolveConfig';
import tailwindConfig from '../../tailwind.main.config.mjs';

let config: TailwindConfig = resolveConfig(tailwindConfig);

const tailwindCss = createTailwindcss({tailwindConfig: {
	theme: config.theme,
	important: '.cms-sections',
	// prefix: 'cms-'
}});

export default async function tailwindCompiler(html: string) {
	return tailwindCss.generateStylesFromContent(`@tailwind utilities;`, [html]);
}
